import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedProductState {
  selectedProduct: boolean;
}

const initialState: SelectedProductState = {
  selectedProduct: false,
};

export const selectedProductSlice = createSlice({
  name: 'selectedProduct',
  initialState,
  reducers: {
    setSelectedProduct: (state, action: PayloadAction<any>) => {
      state.selectedProduct = !state.selectedProduct;
    },
  },
});

export const { setSelectedProduct } = selectedProductSlice.actions;